import { Factory } from 'miragejs';
import { faker } from '@faker-js/faker';

export default Factory.extend({
  name: () => faker.lorem.word(),
  notes: null,
  enabled: true,
  shouldCreateUtilization: true,

  afterCreate(feature, server) {
    const status = server.create('graphql/room-status', { status: 'Available', time: '2019-01-01T00:00:00.000Z' });
    feature.update({
      type: 'room',
      room: server.create('graphql/room', {
        name: faker.lorem.word(),
        status,
        calendarId: 1,
        amenities: [],
        claimable: true,
        checkInEnabled: true,
        shouldCreateUtilization: feature.shouldCreateUtilization,
      }),
    });
  },
});
